/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-component-props */
import React, { Component } from "react";
import { connect } from "react-redux";
import { push, replace } from "react-router-redux";
import "./ABNavbar.css";
import PropTypes from "prop-types";
import { Button, Divider } from "antd";
import { getChannel } from "metabase/selectors/app";
import { logout } from "metabase/auth/actions";
import {
  getCancelFeedback,
  getCreateFgaProjectModalShow,
  getCreateModalShow,
  getLoginModalDefaultRegister,
  getLoginModalRedirect,
  getLoginModalShow,
} from "metabase/selectors/control";
import {
  cancelFeedbackAction,
  createFgaProjectModalShowAction,
  createModalShowAction,
  loginModalShowAction,
  setIsCancelFeedbackBlockAction,
} from "metabase/redux/control";
import GaProjectSearch from "metabase/ab/components/GaProjectSearch";
import Link from "metabase/core/components/Link";
import { getOssUrl } from "metabase/lib/image";
import Modal from "metabase/components/Modal";
import CreateActionModal from "metabase/components/CreateActionModal";
import Icon from "metabase/components/Icon";
import LogoIcon from "metabase/components/LogoIcon";
import EntityMenu from "metabase/components/EntityMenu";
import CreateProjectModal from "metabase/ab/components/Modal/CreateProjectModal";
import { isFgaPath, isFgaPathProject } from "metabase/ab/utils/utils";
import MyUserProfile from "metabase/nav/components/MyUserProfile";
import { getContext, getPath, getUser } from "../selectors";
import { getFgaProject } from "../../../selectors/user";
import { isFgaChartPath } from '../../../ab/utils/utils';
import SearchBar from "metabase/nav/components/SearchBar";

const mapStateToProps = (state, props) => ({
  path: getPath(state, props),
  context: getContext(state, props),
  user: getUser(state),
  loginModalShow: getLoginModalShow(state, props),
  loginModalDefaultRegister: getLoginModalDefaultRegister(state, props),
  createFgaProjectModalShow: getCreateFgaProjectModalShow(state, props),
  loginModalRedirect: getLoginModalRedirect(state, props),
  createModalShow: getCreateModalShow(state, props),
  cancelFeedback: getCancelFeedback(state, props),
  channel: getChannel(state) || "homepage",
  projectObject: getFgaProject(state),
});

const mapDispatchToProps = {
  onChangeLocation: push,
  setLoginModalShow: loginModalShowAction,
  setCreateFgaProjectModalShowAction: createFgaProjectModalShowAction,
  setCreateModalShow: createModalShowAction,
  cancelFeedbackAction,
  setIsCancelFeedbackBlockAction,
  logout,
  replace,
};

class ABNavbar extends Component {
  static propTypes = {
    context: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    channel: PropTypes.string.isRequired,
    user: PropTypes.object,
  };

  state = {
    sideNavModal: false,
    // isProjectModalOpen: false,
  };

  isActive(path) {
    return this.props.path === path;
  }

  renderModal() {
    const {
      createModalShow,
      setCreateModalShow,
      // onChangeLocation,
    } = this.props;

    return (
      createModalShow && (
        <Modal
          className="w-auto"
          ModalClass="z-index-top"
          onClose={() => setCreateModalShow({ show: false })}
        >
          <CreateActionModal
            showNewDashboard={() => {
              const newDashboardUrl = `${
                isFgaPath() ? "/ab" : ""
              }/dashboard/new`;
              window.open(newDashboardUrl);
            }}
            onClose={() => setCreateModalShow({ show: false })}
            onCloseSideBar={this.props.onClose}
          />
        </Modal>
      )
    );
  }

  renderEmptyNav() {
    return (
      // NOTE: DO NOT REMOVE `Nav` CLASS FOR NOW, USED BY MODALS, FULLSCREEN DASHBOARD, ETC
      // TODO: hide nav using state in redux instead?
      <nav className="fga-Nav sm-py1 relative">
        <ul className="wrapper flex align-center">
          <li>
            <Link
              to="/ab"
              data-metabase-event={"Navbar;Logo"}
              className="NavItem cursor-pointer flex align-center"
              onClick={e => {
                e.preventDefault();
                this.goLink(e, "/ab");
              }}
            >
              <LogoIcon className="text-brand my2"/>
            </Link>
          </li>
        </ul>
      </nav>
    );
  }

  goLink = (e, url, open = false) => {
    e.preventDefault();
    this.setState({ sideNavModal: false });
    const afterSuccess = () => {
      if (open) {
        window.open(url);
      } else {
        this.props.onChangeLocation(url);
      }
    };
    afterSuccess();
  };

  renderNavEntityMenu({ item, className, fromDrawer }) {
    if (fromDrawer) {
      return (
        <div className="flex flex-column w-full">
          <div className={className}>
            {/*{item.icon && <Icon name={item.icon} size={16} />}*/}
            <span>{item.name}</span>
            <Icon className="ml1" name="search_arrow_up" size={12}/>
          </div>
          <div>
            {item.menu.map((item, index) => {
              return (
                <Link
                  className={className}
                  key={index}
                  to={item.link}
                  target={item.externalLink ? "_blank" : null}
                  onClick={e => {
                    this.goLink(e, item.link, item.externalLink);
                  }}
                >
                  <span>{item.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      );
    }
    return (
      <EntityMenu
        items={item.menu}
        triggerProps={{
          style: {
            color: "#5F6368",
            marginTop: 20,
          },
        }}
        hasArrow={true}
        hasBackground={true}
        menuShiftY={0}
        renderChildren={
          <div
            className={className}
          >
            <span>{item.name}</span>
            <Icon className="ml1" name="search_arrow_up" size={12}/>
          </div>
        }
      />
    );
  }

  renderMainNav() {
    const {
      user,
      setLoginModalShow,
      setCreateFgaProjectModalShowAction,
      createFgaProjectModalShow,
      location,
    } = this.props;
    const rootDisplay = window.location.pathname.startsWith("/defi360")
      ? "none"
      : "flex";

    const RightMenu = () => {
      const projectName = this.props?.projectObject?.projectName;
      return (
        <div className="Nav__right">
          {isProjectPage() && (<div className="Nav__starter-guide">
            <span>Don't know where to start?</span>
            <div className={"flex align-center cursor-pointer"}>
              <img src={getOssUrl("/ab/icon_starter_guide.svg")}/>
              <h4>Starter Guide</h4>
            </div>
          </div>)}
          <Divider type={"vertical"} style={{ marginBottom: -4, height: 32 }}/>
          {user ? (
            <MyUserProfile
              {...this.props}
              projectName={projectName}
              onLogout={() => {
                this.props.logout();
              }}
            />
          ) : (
            <Button
              className="ml2"
              onClick={() => {
                setLoginModalShow({ show: true, from: "navbar_fga_signin" });
              }}
            >
              Sign in
            </Button>
          )}
        </div>
      );
    };
    const isProjectPage = () => {
      return location?.pathname?.startsWith("/ab/project") || location?.pathname === "/ab" || location?.pathname === "/ab/" || location?.pathname === "/";
    }
    return (
      <div className="fga-Nav" style={{ display: rootDisplay }}>
        <div className="Nav__left">
          <div style={{ width: 0, height: "0px", visibility: "hidden" }}>
            <GaProjectSearch
              dispatch={this.props.dispatch}
              location={location}
              logout={this.props.logout}
              setCreateFgaProjectModalShowAction={
                setCreateFgaProjectModalShowAction
              }
            />
          </div>
          {!isProjectPage() && (<Link
            className="Nav__logo"
            to="/ab"
            onClick={e => {
              e.preventDefault();
              // trackStructEvent(`navbar-click-logo`);
              this.goLink(e, "/ab");
            }}
          >
            <img
              src={getOssUrl(
                "ab/tb-logo.png",
              )}
              width={36}
              height={36}
              style={{ marginBottom: 2 }}
            />
            <span className="ml4">Telegraph Bay</span>
          </Link>)}
          {isProjectPage() && <SearchBar location={location} isDark={true}/>}
        </div>
        <RightMenu/>
        {this.renderModal()}
        <CreateProjectModal
          open={createFgaProjectModalShow?.show}
          force={createFgaProjectModalShow?.force}
          location={location}
          onSuccess={() => {
            setCreateFgaProjectModalShowAction({ show: false });
          }}
          onCancel={() => {
            setCreateFgaProjectModalShowAction({ show: false });
          }}
        />
      </div>
    );
  }

  render() {
    const { context } = this.props;
    switch (context) {
      case "auth":
        return null;
      case "none":
        return this.renderEmptyNav();
      case "setup":
        return null;
      default:
        return this.renderMainNav();
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ABNavbar);
